import React from 'react';
import commonSvg from 'commonSvgPath/common.svg'; // eslint-disable-line

const commonSvgHtml = {
  __html: commonSvg
};

export default function SvgIcons() {
  return (
    <div style={{ display: 'none' }} dangerouslySetInnerHTML={commonSvgHtml} /> // eslint-disable-line
  );
}



// WEBPACK FOOTER //
// ./src/components/SvgIcons.jsx